import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { RUNTIME_CONFIG } from './runtime-config';

export const apiBaseUrlInterceptor: HttpInterceptorFn = (request, next) => {
  const { apiBaseUrl } = inject(RUNTIME_CONFIG);

  if (!apiBaseUrl || (request.url !== '/api' && !request.url.startsWith('/api/'))) {
    return next(request);
  }

  const apiPath = request.url.slice('/api'.length);
  return next(request.clone({ url: `${apiBaseUrl}${apiPath}` }));
};
